/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { AuthStrictHttpResponse } from '../../auth-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RoleModel } from '../../models/role-model';

export interface RolePost$Params {
      body?: RoleModel
}

export function rolePost(http: HttpClient, rootUrl: string, params?: RolePost$Params, context?: HttpContext): Observable<AuthStrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, rolePost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as AuthStrictHttpResponse<string>;
    })
  );
}

rolePost.PATH = '/Role';
